import React from 'react';
import { Avatar, Popover } from 'antd';
import { UserOutlined } from '@ant-design/icons';

import styles from './Map.module.css';

type MarkerProps = {
  text: string;
  meta: string | undefined;
  lat?: number;
  lng?: number;
  isCenter?: boolean;
};

export const Marker: React.FC<MarkerProps> = ({ text, meta, isCenter }) => (
  <div className={isCenter ? styles.centerMarker : styles.marker}>
    <Popover content={text}>
      <Avatar
        src={meta}
        icon={<UserOutlined />}
        alt={text}
        size={33}
        className={styles.markerIcon}
      />
    </Popover>
  </div>
);
